
App.angular.controller('ParametersController', function($scope, $timeout, $resource, ngTableParams) {

    var Api = $resource('/admin/ajax/parameters');

    $scope.onDomReady = function(tableParams) {

        // Initializes ng-table
        $scope.tableParams = new ngTableParams(
            tableParams,
            {
                total: 0,
                getData: function($defer, params) {
                    $scope.loading = true;
                    Api.get(params.url(), function(data) {
                        $timeout(function() {
                            $scope.loading = false;
                            params.total(data.total);
                            $defer.resolve(data.result);
                        }, 500);
                    });
                }
            }
        );
    };
});